module.exports = "/_next/static/images/empty-7e271795.png";